<template>
  <v-layout column align-center>
    <v-img class="mb-3" id="face"
      :src="img"
      :lazy-src="lazyImg"
      :min-width="imgSize"
      :max-width="imgSize"
    />

    <p
      class="display-1"
      v-html="title"
    />

    <p
      class="subheading home"
      style="margin: 0;"
      v-if="description"
      v-html="description"
    />
  </v-layout>
</template>

<script>
let image = require('./image.json');

export default {
  data() {
    return {
      img: '/img/face.jpg',
      lazyImg: image.base64,

      title: `Hi! I'm Gabriel.`,

      description: `
        I am a Software Engineer at <a target="_blank" href="https://www.bifrost.ai/">Bifrost</a>.
      `,
    };
  },

  computed: {
    imgSize() {
      if (this.$vuetify.breakpoint.smAndUp) return 256;
      else return 168;
    },
  },
};
</script>

<style>
#face .v-image__image {
  border-radius: 50%;
}
</style>
